__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/c1a6773/_next/";